/**
 * Add Font Awesome icons to stuff
 *
 * @since   1.0.0
 * @package bigblue
 */

(function($) {
	$(document).ready(function() {

		$.each({
			'.checkin-steps .elementor-column + .elementor-column' : 'long-arrow-alt-right',
		}, beforeIcon );

		/**
		 * Add an icon before a jQuery object
		 *
		 * @param {string} thing selector
		 * @param {string} icon  name of Font Awesome icon (like file-text)
		 */
		function beforeIcon( thing, icon ) {
			$( thing ).before( '<i class="far fa-' + icon + '"></i>' );
		}

		$.each({
			'.validation_message'    						: 'exclamation-triangle',
			'.ginput_container_date' 						: 'calendar-alt',
		}, prependIcon );

		/**
		 * Prepend an icon to a jQuery object
		 *
		 * @param {string} thing selector
		 * @param {string} icon  name of Font Awesome icon (like file-text)
		 */
		function prependIcon( thing, icon ) {
			$( thing ).prepend( '<i class="far fa-' + icon + '"></i>' );
		}

		$.each({
			'.elementor-widget-pp-posts .pp-button-text' 			: 'long-arrow-alt-right',
			'.elementor-widget-posts .elementor-post__read-more' 	: 'long-arrow-alt-right',
			'.elementor-widget-posts .page-numbers.next'			: 'chevron-right',
			'.elementor-widget-posts .page-numbers.prev'			: 'chevron-left',
			'.case-studies .elementor-cta__button' 					: 'long-arrow-alt-right',
		}, appendIcon );

		/**
		 * Add an icon before a jQuery object
		 *
		 * @param {string} thing selector
		 * @param {string} icon  name of Font Awesome icon (like file-text)
		 */
		function appendIcon( thing, icon ) {
			$( thing ).append( '<i class="far fa-' + icon + '"></i>' );
		}

		// Replacing broken elementor icons
		var $icons = $('.elementor-widget-icon .elementor-icon');

		// Remove existing icon
		$icons.find('.fa').remove();

		// Append new FA5 icons
		$icons.append( '<i class="far fa-long-arrow-alt-right"></i>' );

	}); // document.ready
})(jQuery);
